import axios from "axios";

// Base URL for API request
  const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://shopmytool.in';


  // const API_BASE_URL = 'http://192.168.0.154:8000';
  // const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://192.168.0.165:8000';




// Create an Axios instance
const Axios = axios.create({

  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    //  'client':'9',
  },
});

// Add request interceptor to include token
Axios.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.authorization = `Bearer ${token}`;
    } 
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptor to handle 401 errors
Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);

export default Axios;
